import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useAddFundMutation } from '@/react-query/mutations/funds'

import { type SchemaType, schema } from './AddFundForm.schema'

export interface AddFundFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const AddFundForm: React.FC<AddFundFormProps> = ({ children, onSubmit, ...props }) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const addFundMutation = useAddFundMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (data, _e) => {
        await addFundMutation.mutateAsync(data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
